import isMACAddress from 'validator/lib/isMACAddress'

export default {
  methods: {
    errorHandler (error) {
      if (error.response.data.error) this.errorSnack(this.$store.state.lang[this.$store.getters.appLang][error.response.data.error])
      else this.errorSnack(error.message)
      return error
    },
    errorSnack (message) {
      let errMessage = document.getElementById('errorMessage')
      let errorSnack = document.getElementById('errorSnack')
      errMessage.innerHTML = message
      errorSnack.classList.add('active-snack')
      setTimeout(function () { errorSnack.classList.remove('active-snack') }, 2000)
    },
    successSnack (message) {
      let successMessage = document.getElementById('successMessage')
      let successSnack = document.getElementById('successSnack')
      successMessage.innerHTML = message
      successSnack.classList.add('active-snack')
      setTimeout(function () { successSnack.classList.remove('active-snack') }, 2000)
    },
    formatAndCheckParams () {
      let urlUserMac
      let urlApMac
      let authUrl
      let vendor = this.route.query.vendor || 'unifi'
      switch (vendor) {
        case 'tplink': {
          urlUserMac = this.route.query.clientMac.toLowerCase().replace(/-/g, ':')
          urlApMac = this.route.query.ap.toLowerCase().replace(/-/g, ':')
          authUrl = 'http://192.168.0.192:22080/portal/auth'
          break
        }
        case 'mikrotik': {
          urlUserMac = this.route.query.id.toLowerCase().replace(/-/g, ':')
          urlApMac = this.route.query.ap.toLowerCase().replace(/-/g, ':')
          authUrl = 'http://192.168.6.1/login?dst='
          break
        }
        case 'teltonika': {
          urlUserMac = this.route.query.id.toLowerCase().replace(/-/g, ':')
          urlApMac = this.route.query.ap.toLowerCase().replace(/-/g, ':')
          authUrl = 'http://' + this.route.query.uamip + ':' + this.route.query.uamport + '/logon?'
          if (this.route.query.res === 'success') {
            window.location.href = this.landingPage || 'http://nimmshop.at'
          }
          break
        }
        case 'meraki': {
          urlUserMac = this.route.query.client_mac.toLowerCase().replace(/-/g, ':')
          urlApMac = this.route.query.ap_mac.toLowerCase().replace(/-/g, ':')
          authUrl = this.route.query.login_url
          break
        }
        case 'unifi': {
          if (this.route.query.id) urlUserMac = this.route.query.id.toLowerCase().replace(/-/g, ':')
          if (this.route.query.ap) urlApMac = this.route.query.ap.toLowerCase().replace(/-/g, ':')
          authUrl = ''
          break
        }
        case 'unifi-direct': {
          urlUserMac = this.route.query.id.toLowerCase().replace(/-/g, ':')
          urlApMac = this.route.query.ap.toLowerCase().replace(/-/g, ':')
          authUrl = ''
          break
        }
        case 'aruba': {
          urlUserMac = this.route.query.mac.toLowerCase().replace(/-/g, ':')
          urlApMac = this.route.query.apmac.toLowerCase().replace(/-/g, ':')
          authUrl = this.route.query.switchip
          break
        }
        case 'openwrt': {
          urlUserMac = this.route.query.mac.toLowerCase().replace(/-/g, ':')
          urlApMac = this.route.query.called.toLowerCase().replace(/-/g, ':')
          authUrl = 'http://' + this.route.query.uamip + ':' + this.route.query.uamport + '/logon?'
          if (this.route.query.res === 'success') {
            window.location.href = this.landingPage || 'http://google.com'
          }
          break
        }
      }
      this.$store.commit('setVendor', vendor)
      this.$store.commit('setAuthUrl', authUrl)
      this.$store.commit('setUrlUserMac', urlUserMac)
      this.$store.commit('setUrlApMac', urlApMac)

      return !(urlUserMac !== undefined && isMACAddress(urlUserMac) && urlApMac !== undefined && isMACAddress(urlApMac))
    },
    getMinutes (hours, minutes) {
      return parseInt(hours) * 60 + parseInt(minutes)
    },
    /** Function which checks if provided object is empty  */
    isEmpty (obj) {
      for (let prop in obj) {
        if (obj.hasOwnProperty(prop)) {
          return false
        }
      }
      return JSON.stringify(obj) === JSON.stringify({})
    },
    applyTimeFilter (post) {
      if (!post.time_filter) return true

      let currentDateTime = this.$moment(new Date()).format('YYYY-MM-DD')
      let currentDayTime = this.$moment(new Date()).format('HH:mm').split(':')
      let postDayTimeFrom = post.time_filter.dayTimeFrom.split(':')
      let postDayTimeTo = post.time_filter.dayTimeTo.split(':')

      let currentMinutes = this.getMinutes(currentDayTime[0], currentDayTime[1])
      let postDayTimeFromMinutes = this.getMinutes(postDayTimeFrom[0], postDayTimeFrom[1])
      let postDayTimeToMinutes = this.getMinutes(postDayTimeTo[0], postDayTimeTo[1])

      if (post.time_filter.everyDateTime) {
        if (post.time_filter.everyDayTime) return true
        else return currentMinutes > postDayTimeFromMinutes && currentMinutes < postDayTimeToMinutes
      } else {
        if (this.$moment(currentDateTime).isBetween(post.time_filter.dateTimeFrom, post.time_filter.dateTimeTo, 'minutes')) {
          if (post.time_filter.everyDayTime) return true
          else return currentMinutes > postDayTimeFromMinutes && currentMinutes < postDayTimeToMinutes
        } else return false
      }
    }
  }
}



// WEBPACK FOOTER //
// ./src/mixins/global.mixin.js